import ThisModule from "./FooterIconLink";

export default ThisModule;
